import { ENDPOINT_REQUEST, sendMsg, SERVICES_REQUEST } from "../../configurations";

export const ConfigServices = {
    getConfigSettingsService,
}

function getConfigSettingsService(params, callback) {
  sendMsg(SERVICES_REQUEST.COMMON_V1, ENDPOINT_REQUEST.iCONFIG.GET_CONFIG_SETTINGS, params).get(res => {
    callback(res);
  })
}
